
(() => {

    const {get, postFile}= require('./request')
    const {parse} = require('./html')
    const layout = require('./documents.html')
    const errorLayout = require('./error.html')
    
    const App = require('./app/app')

    const API = {host: API_HOST || '127.0.0.1', port: API_PORT || 8080}
    
    window.addEventListener('DOMContentLoaded', () => {
        const api = API
        const {host, port} = api
        get(host, port, `/document`).then(({documents: docs}) => {
            Promise.all(docs.map(name => get(host, port, `/document/${name}/meta`))).then((result) => {
                const documents = result.map(({title, author, sections, password}, i) => ({name: docs[i], title, author, sections, password}))
                const content = parse(layout, {documents}).firstChild
                documents.forEach((document) => {
                    const {name} = document
                    content.querySelector(`#document-${name.replace(/ /g, '_')}`).addEventListener('click', () => {
                        const app = new App(api, document)
                        window.document.body.innerHTML = ''
                        window.document.body.appendChild(app.dom())
                    })
                })
                const uploadForm = content.querySelector('form#upload-form')
                content.querySelector('button#toggle-upload').addEventListener('click', () => {
                    uploadForm.style.display = uploadForm.style.display === 'none' ? 'block' : 'none'
                })
                // 파일 업로드 버튼 클릭
                uploadForm.addEventListener('submit', (event) => {
                    event.preventDefault()
                    const title = uploadForm.querySelector('#title').value
                    const password = uploadForm.querySelector('#password').value || undefined
                    const confirm = uploadForm.querySelector('#confirm').value || undefined
                    if(title.trim() !== '' && password === confirm) {
                        postFile(host, port, '/document', uploadForm).then((response) => {
                            alert('문서를 올렸습니다.')
                            location.reload()
                        })
                    }
                    return true
                })
                window.document.body.appendChild(content)
            })
        }).catch((reason) => {
            console.error(reason)
            const content = parse(errorLayout, {reason: `API request failure: ${reason}`}).firstChild
            window.document.body.appendChild(content)
        })
    })
})()
